import { Input } from 'antd';

const { TextArea } = Input;

export default function TemplateEditor({
  value = '',
  onChange,
  placeholder = 'e.g.  ${{clientRate}} /{{rateType}}',
  disabled = false,
  textareaRef,
}) {
  return (
    <TextArea
      ref={textareaRef}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      autoSize={{ minRows: 2, maxRows: 6 }}
      spellCheck={false}
      onChange={(event) => onChange?.(event.target.value)}
      style={{
        width: '100%',
        fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
        fontSize: 12,
        lineHeight: '20px',
        resize: 'vertical',
      }}
    />
  );
}
